import { REST_METHOD, REST_URL } from 'constants/index';
import { requestAudit } from './api';

export interface LogRequestPayload {
  user_id: string;
  impersonate_user_id: string;
  type: string;
  message: string;
}

async function logRequest(payload: LogRequestPayload) {
  try {
    const requestParams = {
      url: `${REST_URL.AUDIT}${REST_URL.UPTIME_LOG}`,
      method: `${REST_METHOD.POST}`,
      data: payload,
    };

    const response = await requestAudit(requestParams);
    return response.data;
  } catch (error) {
    console.error('Failed to log request', error);
  }
}

const AuditServices = {
  logRequest,
};

export default AuditServices;
